import { ajax } from '@utils/ajax';
//import mockData from '../mocks';

export default () => {
	return ajax.get(`/settings/account/billing/invoices`).then(({ data }) => {
		//return [...data, ...mockData];
		return data;
	});
};
